import request from '@/utils/request'
const construction = 'construction/'
const stock_records = 'stock_records/'

// 库存记录
export function getStockRecords(listQuery) {
  return request({ url: `${construction}${stock_records}`, method: 'GET', params: listQuery })
}

